import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5l0 14","key":"svg-0"}],["path",{"d":"M12 5l0 14","key":"svg-1"}],["path",{"d":"M16 5l0 14","key":"svg-2"}]]

/**
 * IconTallymark3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGFsbHltYXJrLTMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggNWwwIDE0IiAvPgogIDxwYXRoIGQ9Ik0xMiA1bDAgMTQiIC8+CiAgPHBhdGggZD0iTTE2IDVsMCAxNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/tallymark-3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTallymark3 = createReactComponent('outline', 'tallymark-3', 'Tallymark3', __iconNode);

export default IconTallymark3;